import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class UIBlockerService {

    uiBlocker: EventEmitter<boolean> = new EventEmitter();

    constructor() { /* noop */
    }

    blockUI() {
        this.uiBlocker.emit(true);
    }

    unBlockUI() {
        this.uiBlocker.emit(false);
    }

}
